import useTeamMembersByRole from "./useTeamMembersByRole";

export default function useTeamMemberByRole({ team, role, user }) {
	const members = useTeamMembersByRole({ team, role });

	return members.find((member) => member.user?.id === user?.id);
}
